var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "detailed-table" },
    [
      !_vm.disabled
        ? _c("vxe-toolbar", {
            scopedSlots: _vm._u(
              [
                {
                  key: "buttons",
                  fn: function () {
                    return [
                      _c(
                        "el-link",
                        {
                          attrs: { type: "primary", icon: "el-icon-plus" },
                          on: { click: _vm.addTable },
                        },
                        [_vm._v("新增")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2948762210
            ),
          })
        : _vm._e(),
      _c(
        "vxe-table",
        {
          ref: "xTable",
          attrs: {
            resizable: "",
            "show-overflow": "",
            data: _vm.valueList,
            "edit-config": {
              trigger: "click",
              mode: "cell",
              activeMethod: _vm.activeCellMethod,
            },
          },
          on: { "radio-change": _vm.radioChangeEvent },
        },
        [
          _vm._l(_vm.columns, function (item, k) {
            return _c(
              "vxe-table-column",
              _vm._b(
                {
                  key: k,
                  scopedSlots: _vm._u(
                    [
                      item.field === "wayMoney"
                        ? {
                            key: "edit",
                            fn: function ({ row, rowIndex }) {
                              return [
                                _c("div", [
                                  row.wayType === "2"
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "edit",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openRandom(
                                                  row,
                                                  rowIndex
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  row.randomName || "编辑"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _c(
                                        "div",
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              precision: 2,
                                              controls: false,
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value: row.wayMoney,
                                              callback: function ($$v) {
                                                _vm.$set(row, "wayMoney", $$v)
                                              },
                                              expression: "row.wayMoney",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                ]),
                              ]
                            },
                          }
                        : null,
                      {
                        key: "default",
                        fn: function ({ row, rowIndex }) {
                          return [
                            item.field === "wayMoney"
                              ? _c("div", [
                                  row.wayType === "2"
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "edit",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openRandom(
                                                  row,
                                                  rowIndex
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  row.randomName || "编辑"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _c(
                                        "div",
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              precision: 2,
                                              controls: false,
                                              disabled: _vm.disabled,
                                            },
                                            model: {
                                              value: row.wayMoney,
                                              callback: function ($$v) {
                                                _vm.$set(row, "wayMoney", $$v)
                                              },
                                              expression: "row.wayMoney",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                ])
                              : _vm._e(),
                            item.field === "isRemoteReward"
                              ? _c("div", [
                                  row.scanType === "1"
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                placeholder:
                                                  "请选择是否异地奖励",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.getReward(
                                                    row,
                                                    rowIndex
                                                  )
                                                },
                                              },
                                              model: {
                                                value: row.isRemoteReward,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    row,
                                                    "isRemoteReward",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "row.isRemoteReward",
                                              },
                                            },
                                            _vm._l(
                                              _vm.cpsRemoteReward,
                                              function (oitem) {
                                                return _c("el-option", {
                                                  key: oitem.dictCode,
                                                  attrs: {
                                                    label: oitem.dictValue,
                                                    value: oitem.dictCode,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                placeholder:
                                                  "请选择是否异地奖励",
                                                disabled: "",
                                              },
                                              model: {
                                                value: row.isRemoteReward,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    row,
                                                    "isRemoteReward",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "row.isRemoteReward",
                                              },
                                            },
                                            _vm._l(
                                              _vm.cpsRemoteReward,
                                              function (oitem) {
                                                return _c("el-option", {
                                                  key: oitem.dictCode,
                                                  attrs: {
                                                    label: oitem.dictValue,
                                                    value: oitem.dictCode,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                ])
                              : _vm._e(),
                            _c("div", [
                              _vm._v(_vm._s(_vm.resetText(row, item.field))),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                "vxe-table-column",
                _vm.itemRender(item),
                false
              )
            )
          }),
          !_vm.disabled
            ? _c("vxe-table-column", {
                attrs: {
                  fixed: "right",
                  title: "操作",
                  align: "center",
                  width: "80",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-popconfirm",
                            {
                              attrs: {
                                title: "此操作将永久删除该数据？",
                                "confirm-button-type": "text",
                              },
                              on: {
                                confirm: function ($event) {
                                  return _vm.removeRow(
                                    scope.row,
                                    scope.rowIndex
                                  )
                                },
                              },
                            },
                            [
                              !scope.row.disabled
                                ? _c("el-button", {
                                    staticClass: "text-red",
                                    attrs: {
                                      slot: "reference",
                                      type: "text",
                                      icon: "el-icon-delete",
                                    },
                                    slot: "reference",
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3781168242
                ),
              })
            : _vm._e(),
        ],
        2
      ),
      _c("SelectConfig", {
        ref: "SelectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
      _c(
        "Modal",
        {
          attrs: {
            modalConfig: _vm.modalConfig,
            visible: _vm.modalConfig.visible,
          },
          on: {
            "update:modalConfig": function ($event) {
              _vm.modalConfig = $event
            },
            "update:modal-config": function ($event) {
              _vm.modalConfig = $event
            },
            "update:visible": function ($event) {
              return _vm.$set(_vm.modalConfig, "visible", $event)
            },
            onClose: _vm.closeModal,
          },
        },
        [
          _c(_vm.formName, {
            ref: _vm.formName,
            tag: "component",
            attrs: { formConfig: _vm.formConfig, disabled: _vm.disabled },
            on: { closeModal: _vm.closeModal },
          }),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-submit", type: "primary" },
                  on: { click: _vm.submit },
                },
                [_vm._v("提交")]
              ),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-close", type: "danger" },
                  on: { click: _vm.closeModal },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }